import React from 'react';
import { withRouter, Link } from 'react-router-dom';

class Notification extends React.Component {

    render() {
        const notifications = this.props.notifications || [];
        var is_modal = false;
        if (typeof this.props.showModal === 'function') {
            is_modal = true;
        }

        return (
            <React.Fragment>
                <div className={`${is_modal ? 'modal-content' : ''}`}>
                    {is_modal ? (
                        <div className="modal-header">
                            <h5 className="modal-title">Liste des notifications</h5>
                            <button type="button" className="close btn-link btn mt-2" onClick={() => this.props.showModal(false)}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                    ) : (
                            <div className="row mb-4 bg-template-opacity">
                                <div className="container py-4">
                                    <div className="row">
                                        <div className="col">
                                            <h5 className="font-weight-normal template-primary">Notifications</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    <div className="modal-body p-0">
                        <div className="arrow pink-gradient"></div>
                        {notifications.map((notif, indice) =>
                            <div className="notification-row new" key={indice}>
                                <div className="row">
                                    <div className="col-auto"></div>
                                    <div className="col pl-0">
                                        <Link replace to={`/colis/list?statut_alert=` + notif.statut_alert + '&t=' + Date.now() + '&title=' + notif.title} onClick={() => this.showModal(false)} style={{ 'color': '#333333' }}>
                                            <b className="text-mute">{notif.title}</b>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    showModal = () => {
        if (typeof this.props.showModal === 'function') {
            this.props.showModal(false);
        }
    }

}

export default withRouter(Notification);